import { ApiCallActionTypes, TypesEnum, ApiCall } from './types';

export function apiCallBegan(apiCall: ApiCall): ApiCallActionTypes {
    return {
        type: TypesEnum.apiCallBegan,
        payload: apiCall,
    };
}

export function apiCallSuccess(data: any): ApiCallActionTypes {
    return {
        type: TypesEnum.apiCallSuccess,
        payload: data,
    };
}

export function apiCallFailed(error: any): ApiCallActionTypes {
    return {
        type: TypesEnum.apiCallFailed,
        payload: error,
    };
}
